import type { Plugin } from 'vue';
import { ModuleRegistry, ValidationModule } from 'ag-grid-community';
import { LicenseManager } from 'ag-grid-enterprise';

export const agGridPlugin: Plugin = {
  install() {
    ModuleRegistry.registerModules(
      import.meta.env.DEV || import.meta.env.VITE_STAGE === 'dev' || import.meta.env.VITE_STAGE === 'uat'
        ? [ValidationModule]
        : [],
    );

    if (import.meta.env.VITE_AG_GRID_LICENSE_KEY) {
      LicenseManager.setLicenseKey(import.meta.env.VITE_AG_GRID_LICENSE_KEY);
    }
  },
};
